import Box from "@mui/material/Box";
import type { OnboardingLayoutProps } from "./types";
import { useOnboardingStep } from "../hooks";

const OnboardingStep = ({ route, getApplicationModel, ...restProps }: OnboardingLayoutProps) => {
    const { getCurrentStepModel } = useOnboardingStep({
        route,
        getApplicationModel
    });

    return (
        <Box
            {...restProps}
            sx={{
                display: 'grid',
                gridTemplateColumns: `1fr 20% ${getCurrentStepModel()?.layout?.stepContainerSize ?? '480px'} 1fr`,
                gap: 15,
                '::before': {
                    content: '""',
                    display: 'block'
                },
                '::after': {
                    content: '""',
                    display: 'block'
                },
                ...restProps.sx
            }}
        />
    );
};

export default OnboardingStep;
